import { BACKEND } from "@/remotes";
import { inject, ref } from "vue";
// import * as rulesForm from "./rulesForm";
import { USER_ID } from "@/consts";
import { useRouter } from 'vue-router';

import { useFetchAvailablePickUpTime } from '@/newCargoPickUpPage/hooks/useFetchAvailablePickUpTime';
import { useFetchDeliveryTimeIntervals } from '@/newCargoPickUpPage/hooks/useFetchDeliveryTimeIntervals';
import { useFetchSuitableOfficesCalculator } from '@/newCargoPickUpPage/hooks/useFetchSuitableOfficesCalculator';
import { useDataFormStore } from "@/stores/form";
import { useNewDataFormCargoPickUpStore } from '@/stores/newFormCargoPickUp';


export default {
    setup() {
        const dataForm = useDataFormStore();
        const newDataForm = useNewDataFormCargoPickUpStore()
        const router = useRouter()


        const showLinkButtons = ref(false);

        const typeOfCargos = [
            {
                value: "Стандарт",
                label: "Стандарт",
            },
            {
                value: "Цилиндры",
                label: "Цилиндры",
            },
            {
                value: "Шины",
                label: "Шины",
            },
        ];
        const typeOfCargosNew = [
          {
            id: 1,
            title: 'Стандарт',
          },
          {
            id: 2,
            title: 'Цилиндры',
          },
          {
            id: 3,
            title: 'Шины',
          },
        ];

        const typeOfPayer = [
            {
                value: false,
                label: "Физическое лицо"
            },
            {
                value: true,
                label: "Юридическое лицо"
            }
        ]

        const typeOfPackagings = [
            {
                value: "Обрешётка",
                label: "Обрешётка",
                disabled: [
                    "Обрешётка",
                    "Стретч-пленка",
                    "Коробка 25x18x10",
                    "Коробка 38x30x23",
                    "Пакет",
                ],
            },
            {
                value: "Паллетирование",
                label: "Паллетирование",
                disabled: [
                    "Паллетирование",
                    "Стретч-пленка",
                    "Коробка 25x18x10",
                    "Коробка 38x30x23",
                    // "Пакет",
                ],
            },
            {
                value: "Стретч-пленка",
                label: "Стретч-пленка",
                disabled: [
                    "Обрешётка",
                    "Паллетирование",
                    "Стретч-пленка",
                    "Коробка 25x18x10",
                    "Коробка 38x30x23",
                    "Пакет",
                    "Поддон",
                ],
            },
            {
                value: "Коробка 25x18x10",
                label: "Коробка 25x18x10",
                disabled: [
                    "Обрешётка",
                    "Паллетирование",
                    "Стретч-пленка",
                    "Коробка 25x18x10",
                    "Поддон",
                ],
            },
            {
                value: "Коробка 38x30x23",
                label: "Коробка 38x30x23",
                disabled: [
                    "Обрешётка",
                    "Паллетирование",
                    "Стретч-пленка",
                    "Коробка 38x30x23",
                    "Поддон",
                ],
            },
            {
                value: "Пакет",
                label: "Пакет",
                disabled: [
                    "Обрешётка",
                    "Паллетирование",
                    "Стретч-пленка",
                    "Пакет",
                    "Поддон",
                ],
            },
            {
                value: "Поддон",
                label: "Поддон",
                disabled: [
                    "Стретч-пленка",
                    "Коробка 25x18x10",
                    "Коробка 38x30x23",
                    "Пакет",
                    "Поддон",
                ],
            },
        ];

        useFetchSuitableOfficesCalculator('acceptanceCargo');
        useFetchSuitableOfficesCalculator('issuanceOfCargo');

        const paramsChanged = (cityType) => {
            if (cityType === 'acceptanceCargo') {
                useFetchSuitableOfficesCalculator('acceptanceCargo');
            } else if (cityType === 'issuanceOfCargo') {
                useFetchSuitableOfficesCalculator('issuanceOfCargo');
            } else {
                useFetchSuitableOfficesCalculator('acceptanceCargo');
                useFetchSuitableOfficesCalculator('issuanceOfCargo');
            }
        }

        function checkIntersectionsTypes(types, typeName) {
            return !(
                dataForm.cargoInformation.typeOfPackaging.filter((type) =>
                    types.includes(type)
                ).length === dataForm.cargoInformation.typeOfPackaging.length &&
                checkWarmPlace(typeName)
            );
        }

        function checkWarmPlace(typeName) {
            if (!dataForm.services.warmPlace) {
                return true;
            }
            return typeName === "Паллетирование" || typeName === "Поддон"
                ? false
                : true;
        }

        function getTypeOfCargo(type) {
            switch (type) {
                case "Стандарт":
                    return "Standart";
                case "Цилиндры":
                    return "Cylinder";
                case "Шины":
                    return "Tires";
            }
        }


        function getTypeOfPackaging(types) {
            return {
                palletizing: types.indexOf("Паллетирование") != -1,
                stretchWrap: types.indexOf("Стретч-пленка") != -1,
                lathing: types.indexOf("Обрешётка") != -1,
                pallet: types.indexOf("Поддон") != -1,
                boxes: Number(getBoxValueByTypes(types))
            };
        }

        function getBoxValueByTypes(types) {
            const BoxesEnum = {
                1: 'Коробка 25x18x10',
                2: 'Коробка 38x30x23',
                3: 'Пакет'
            }

            for (const key in BoxesEnum) {
                if (types.indexOf(BoxesEnum[key]) != -1) {
                    return key
                }
            }

            return 0
        }

        const citiesArr = inject('citiesArr', []);
        const citiesSender = inject('citiesPickup');
        const citiesConsignee = inject('citiesDelivery');

        const isTotalVolume = ref(false);

        const calculatedData = ref({
            shippingCost: {},
        });

        const formRef = ref()

        const submitForm = (formEl) => {
            if (!formEl) return;
            formEl.validate((valid) => {
                if (valid) {
                    sendForCounting();
                } else {
                    return false;
                }
            });
        };

        const formRules = ref({
            "sender.cityFrom": [{required: true, message: "Укажите город отправителя"}],
            "consignee.cityTo": [{required: true, message: "Укажите город получателя"}],
            "cargoInformation.cargoDimensions.length": [{
                validator: checkDimensionsPassed,
                trigger: "blur",
                message: "Введите поле"
            }],
            "cargoInformation.cargoDimensions.width": [{
                validator: checkDimensionsPassed,
                trigger: "blur",
                message: "Введите поле"
            }],
            "cargoInformation.cargoDimensions.height": [{
                validator: checkDimensionsPassed,
                trigger: "blur",
                message: "Введите поле"
            }],
            "cargoInformation.cargoWeight": [{
                validator: checkDimensionsPassed,
                trigger: "blur",
                message: "Введите поле",
            }],
            "cargoInformation.sizeOfCargoCylinder.height": [{
                validator: checkDimensionsPassedForCylinder,
                trigger: "blur", message: "Введите поле"
            }],
            "cargoInformation.sizeOfCargoCylinder.diameter": [{
                validator: checkDimensionsPassedForCylinder,
                trigger: "blur", message: "Введите поле"
            }],
        });

        function checkDimensionsPassed(rule, value, callback) {

            let dimensions = []
            switch (dataForm.cargoInformation.typeOfCargo) {
                case "Цилиндры": {
                    dimensions = [
                        dataForm.cargoInformation.sizeOfCargoCylinder.height,
                        dataForm.cargoInformation.sizeOfCargoCylinder.diameter,
                        dataForm.cargoInformation.cargoWeight,
                    ]
                }
                    break;
                case "Стандарт": {
                    dimensions = [
                        dataForm.cargoInformation.cargoDimensions.length,
                        dataForm.cargoInformation.cargoDimensions.width,
                        dataForm.cargoInformation.cargoDimensions.height,
                        dataForm.cargoInformation.cargoWeight,
                    ]
                }
            }

            if (dimensions.every((dimension) => [null, undefined, ""].includes(dimension))) {
                callback()
            } else if (dimensions.every((dimension) => ![null, undefined, ""].includes(dimension))) {
                callback();
            } else if (Number.isNaN(value) || Number(value) <= 0) {
                callback(new Error());
            } else {
                callback()
            }
        }

        function checkDimensionsPassedForCylinder(rule, value, callback) {
            const dimensions = [
                dataForm.cargoInformation.sizeOfCargoCylinder.height,
                dataForm.cargoInformation.sizeOfCargoCylinder.diameter,
                dataForm.cargoInformation.cargoWeight,
            ];

            if (dimensions.every((dimension) => [null, undefined, ""].includes(dimension))) {
                callback()
            } else if (dimensions.every((dimension) => ![null, undefined, ""].includes(dimension))) {
                callback();
            } else if (Number.isNaN(value) || Number(value) <= 0) {
                callback(new Error());
            } else {
                callback()
            }
        }

        function handleChangeCargoType() {
            dataForm.cargoInformation.sizeOfCargoCylinder.height = null
            dataForm.cargoInformation.sizeOfCargoCylinder.diameter = null
            dataForm.cargoInformation.cargoDimensions.length = null;
            dataForm.cargoInformation.cargoDimensions.width = null;
            dataForm.cargoInformation.cargoDimensions.height = null;
            dataForm.cargoInformation.cargoVolume = null
        }

        function calculateSizesByTotalVolume() {
            if (!isTotalVolume.value)
                return

            switch (dataForm.cargoInformation.typeOfCargo) {
                case "Цилиндры": {
                    const [diameter, height] = calculateCylinderSizes()
                    dataForm.cargoInformation.sizeOfCargoCylinder.diameter = diameter
                    dataForm.cargoInformation.sizeOfCargoCylinder.height = height
                }
                    break
                case "Стандарт": {
                    const [size] = calculateStandartSizes()
                    dataForm.cargoInformation.cargoDimensions.length = size;
                    dataForm.cargoInformation.cargoDimensions.width = size;
                    dataForm.cargoInformation.cargoDimensions.height = size;
                }
                    break
                case "Шины": {
                    //TODO
                }
            }

        }

        function calculateCylinderSizes() {
            const diameter = (Number(dataForm.cargoInformation.cargoVolume * 0.8).toFixed(7)) * 100
            const height = ((4 * (dataForm.cargoInformation.cargoVolume * 1000000) / (3.14 * Math.pow(diameter, 2))).toFixed(7))
            return [diameter, height]
        }

        function calculateStandartSizes() {
            const size = (Math.cbrt(dataForm.cargoInformation.cargoVolume).toFixed(4)) * 100
            return [size]
        }


        async function sendForCounting() {
            calculateSizesByTotalVolume()
            const bodyCalc = {
                cityFrom: dataForm.sender.cityFrom.title,
                cityTo: dataForm.consignee.cityTo.title,
                cargoSpace: getCargoSpace(dataForm.cargoInformation.typeOfCargo),
                cargoPickUp: dataForm.calculator.isCargoPickup === "Забор груза",
                cargoDelivery: dataForm.calculator.isDelivery === "Доставка до адреса",
                cargoDeclaredValue: Number(dataForm.cargoInformation.cargoCost),
                cargoRedemptionAmount: dataForm.services.cargoRedemption
                    ? Number(dataForm.services.cargoRedemptionSum)
                    : 0,
                cashOnDeliveryAmount: dataForm.services.cashOnDelivery
                    ? Number(dataForm.services.cashOnDeliverySum)
                    : 0,
                returnOfDocuments: dataForm.services.returnOfDocuments,
                consignee_inn: dataForm.services.isSenderInn
                    ? 7404067356
                    : null,
                consigneePattern: {
                    "id": "00000000-0000-0000-0000-000000000000",
                    "order": "00000000-0000-0000-0000-000000000000",
                    "relationForClient": null,
                    "addrPickUp": true,
                    "gasolinePickUp": true,
                    "carrying": true,
                    "addrDelivery": true,
                    "gasolineDelivery": true,
                    "packing": true,
                    "comissionForCashOnDelivery": true,
                    "comissionForRepurchase": true,
                    "insuranceForValue": true,
                    "returnDocs": true,
                    "warmPlace": true,
                    "waitingPickUp": true,
                    "waitingDelivery": true,
                    "ptAddrPickUp": 0,
                    "ptGasolinePickUp": 0,
                    "ptCarrying": 0,
                    "ptAddrDelivery": 0,
                    "ptGasolineDelivery": 0,
                    "ptPacking": 0,
                    "ptComissionForCashOnDelivery": 0,
                    "ptComissionForRepurchase": 0,
                    "ptInsuranceForValue": 0,
                    "ptReturnDocs": 0,
                    "ptWaitingPickUp": 0,
                    "ptWaitingDelivery": 0,
                    "ptWarmPlace": 0
                },

            };

            (async function () {
                try {
                    const {data} = await BACKEND.post(
                        `/calc/site?userid=${USER_ID}`,
                        bodyCalc
                    );

                    calculatedData.value = {...data};

                    if (dataForm.cargoInformation.typeOfCargo !== 'Шины')
                        calculatedData.value.totalVolume = dataForm.cargoInformation.cargoVolume;

                    dataForm.applicationCargoPickup.isCargoPickup =
                        calculatedData.value.shippingCost.extraChargeForCargoPickUp > 0
                            ? true
                            : dataForm.applicationCargoPickup.isCargoPickup;
                    dataForm.calculator.isCargoPickup =
                        calculatedData.value.shippingCost.extraChargeForCargoPickUp > 0
                            ? "Забор груза"
                            : dataForm.calculator.isCargoPickup;
                    dataForm.applicationCargoPickup.deliveryToTheAddress =
                        calculatedData.value.shippingCost.extraChargeForCargoDelivery > 0
                            ? true
                            : dataForm.applicationCargoPickup.deliveryToTheAddress;
                    dataForm.calculator.isDelivery =
                        calculatedData.value.shippingCost.extraChargeForCargoDelivery > 0
                            ? "Доставка до адреса"
                            : dataForm.calculator.isDelivery;
                    showLinkButtons.value = true;

                } catch (e) {
                    console.log(e);
                }
            })();
        }

        function checkingDimensions(dimensions) {
            dimensions.sort((a, b) => b - a);
            return dimensions[0] > 100 || dimensions[1] > 70;
        }

        function getCargoSpace(type) {
            const AttachmentCountByTires = 1

            const cargo =
                {
                    cargoType: getTypeOfCargo(dataForm.cargoInformation.typeOfCargo),
                    attachmentCount: Number(
                        dataForm.cargoInformation.numberOfIdenticalLoads
                    ),
                    length: Number(dataForm.cargoInformation.cargoDimensions.length) || 1,
                    width: Number(dataForm.cargoInformation.cargoDimensions.width) || 1,
                    height: Number(
                        getTypeOfCargo(dataForm.cargoInformation.typeOfCargo) ===
                        "Standart"
                            ? dataForm.cargoInformation.cargoDimensions.height || 1
                            : dataForm.cargoInformation.sizeOfCargoCylinder.height
                    ),
                    weight: getWeight(dataForm.cargoInformation.typeOfCargo),
                    diametr: Number(
                        dataForm.cargoInformation.sizeOfCargoCylinder.diameter
                    ),
                    volume: Number(dataForm.cargoInformation.cargoVolume) || 0.000001,
                    cargoExtraPacking: {
                        ...getTypeOfPackaging(
                            dataForm.cargoInformation.additionalPackaging
                                ? dataForm.cargoInformation.typeOfPackaging
                                : []
                        ),
                        warmplace: dataForm.services.warmPlace,
                    },
                }


            if (type !== 'Шины')
                return [cargo]


            return new Array(Number(
                dataForm.cargoInformation.numberOfIdenticalLoads
            )).fill({...cargo, attachmentCount: AttachmentCountByTires})

        }

        function getWeight(type) {
            const TiresWeight = 8

            if (type === 'Шины')
                return TiresWeight

            return dataForm.services.warmPlace
                ? Number(dataForm.cargoInformation.cargoWeight / dataForm.cargoInformation.numberOfIdenticalLoads) || 10
                : Number(dataForm.cargoInformation.cargoWeight) || 10
        }


        function clearCargoDimensions() {
            dataForm.cargoInformation.cargoDimensions.length = null;
            dataForm.cargoInformation.cargoDimensions.width = null;
            dataForm.cargoInformation.cargoDimensions.height = null;
            dataForm.cargoInformation.cargoVolume = null;
        }

        function clearSizeOfCargoCylinder() {
            dataForm.cargoInformation.sizeOfCargoCylinder.height = null;
            dataForm.cargoInformation.sizeOfCargoCylinder.diameter = null;
        }

        // const link = ref("/application-for-pick-up");

        function linkToCreateAnApplication() {
            return dataForm.calculator.isCargoPickup === "Сдать на склад"
                ? "/forwardin-receipt"
                : "/application-for-pick-up";
        }

        const applicationList = [
            {
                value: "Сдать на склад",
                label: "Сдать на склад",
            },
            {
                value: "Забор груза",
                label: "Забор груза",
            },
        ];

        const delivery = [
            {
                value: "Забрать на складе",
                label: "Забрать на складе",
            },
            {
                value: "Доставка до адреса",
                label: "Доставка до адреса",
            },
        ];

        function isBoxesOnly() {
            return ![...dataForm.cargoInformation.typeOfPackaging].reduce(
                (prevtype, curtype) =>
                    prevtype &&
                    !(curtype.includes("Поддон") || curtype.includes("Паллетирование")),
                true
            );
        }
        const calculateVolume = () => {
                if (
                    dataForm.cargoInformation.cargoDimensions.length &&
                    dataForm.cargoInformation.cargoDimensions.width &&
                    dataForm.cargoInformation.cargoDimensions.height
                ) {
                    dataForm.cargoInformation.cargoVolume =
                        ((dataForm.cargoInformation.cargoDimensions.length *
                                dataForm.cargoInformation.cargoDimensions.width *
                                dataForm.cargoInformation.cargoDimensions.height) /
                            1000000).toFixed(3)
                } else if (
                    dataForm.cargoInformation.sizeOfCargoCylinder.height &&
                    dataForm.cargoInformation.sizeOfCargoCylinder.diameter
                ) {
                    dataForm.cargoInformation.cargoVolume = (3.14 *
                        Math.pow((dataForm.cargoInformation.sizeOfCargoCylinder.diameter / 2), 2) *
                        dataForm.cargoInformation.sizeOfCargoCylinder.height /
                        1000000).toFixed(3)
                }
            }

        const dimensionsCargoChange = (dimensionType) => {
            if (dimensionType) {
                calculateVolume(dimensionType);
            }
            useFetchSuitableOfficesCalculator('acceptanceCargo');
            useFetchSuitableOfficesCalculator('issuanceOfCargo');
        }

        return {
            dataForm,
            dimensionsCargoChange,
            citiesArr,
            typeOfCargos,
            typeOfPayer,
            citiesSender,
            citiesConsignee,
            typeOfPackagings,
            checkIntersectionsTypes,
            formRef,
            formRules,
            submitForm,
            sendForCounting,
            calculatedData,
            applicationList,
            linkToCreateAnApplication,
            delivery,
            isTotalVolume,
            handleChangeCargoType,

            clearMeasure: function () {
                clearCargoDimensions();
                clearSizeOfCargoCylinder();
            },

            calculateDimensions: function () {
                console.log(citiesArr.value)
            },
            calculateVolume,

            setPickupPossibility: function (cityName) {
                useFetchSuitableOfficesCalculator('issuanceOfCargo');
                // let {deliveryPickupCategory} = citiesArr.value.find(city => city.name === cityName)

                // if (deliveryPickupCategory === 2) {
                //     dataForm.calculator.isDelivery = "Доставка до адреса"
                //     dataForm.utils.canGetDelivery = true
                // } else {
                //     dataForm.calculator.isDelivery = "Забрать на складе"
                //     dataForm.utils.canGetDelivery = false
                // }
            },

            clearSizeByCargoForm: function (str) {
                switch (str) {
                    case "Цилиндры": {
                        dataForm.cargoInformation.cargoDimensions.length = null;
                        dataForm.cargoInformation.cargoDimensions.width = null;
                        dataForm.cargoInformation.cargoDimensions.height = null;
                        dataForm.cargoInformation.cargoVolume = null
                    }
                        break
                    case "Стандарт": {
                        dataForm.cargoInformation.sizeOfCargoCylinder.height = null
                        dataForm.cargoInformation.sizeOfCargoCylinder.diameter = null
                        dataForm.cargoInformation.cargoVolume = null
                    }
                        break
                    case "Шины" : {
                        dataForm.cargoInformation.cargoDimensions.length = null;
                        dataForm.cargoInformation.cargoDimensions.width = null;
                        dataForm.cargoInformation.cargoDimensions.height = null;
                        dataForm.cargoInformation.sizeOfCargoCylinder.height = null
                        dataForm.cargoInformation.sizeOfCargoCylinder.diameter = null
                        dataForm.cargoInformation.cargoVolume = null
                    }
                        break

                }
                useFetchSuitableOfficesCalculator('acceptanceCargo');
                useFetchSuitableOfficesCalculator('issuanceOfCargo');
            },

            useFetchSuitableOfficesCalculator,

            changeTotalVolume: () => {
                handleChangeCargoType(isTotalVolume.value)
                useFetchSuitableOfficesCalculator('acceptanceCargo');
                useFetchSuitableOfficesCalculator('issuanceOfCargo');
            },

            checkDisabledWarmplace: function () {
                if (
                    isBoxesOnly() ||
                    Number(dataForm.cargoInformation.cargoVolume) > 0.5 ||
                    dataForm.cargoInformation.cargoWeight > (30 * dataForm.cargoInformation.numberOfIdenticalLoads) ||
                    checkingDimensions([
                        dataForm.cargoInformation.cargoDimensions.length,
                        dataForm.cargoInformation.cargoDimensions.width,
                        dataForm.cargoInformation.cargoDimensions.height,
                    ])
                ) {
                    dataForm.services.warmPlace = false;
                    return true;
                }
                return false;
            },

            clearDimensions: function () {
                if (
                    getTypeOfCargo(dataForm.cargoInformation.typeOfCargo) === "Standart"
                ) {
                    clearCargoDimensions();
                    return;
                } else if (
                    getTypeOfCargo(dataForm.cargoInformation.typeOfCargo) === "Cylinder"
                ) {
                    clearCargoDimensions();
                    clearSizeOfCargoCylinder();
                    return;
                }
                clearCargoDimensions();
                clearSizeOfCargoCylinder();
                dataForm.cargoInformation.cargoWeight = null;
            },

            setCargoPickup: function () {
                dataForm.applicationCargoPickup.isCargoPickup =
                    dataForm.calculator.isCargoPickup === "Забор груза";
            },
            setDelivery: function () {
                dataForm.applicationCargoPickup.deliveryToTheAddress =
                    dataForm.calculator.isDelivery === "Доставка до двери";
            },

            checkNumberOfIdenticalLoads: function () {
                if (dataForm.cargoInformation.numberOfIdenticalLoads < 1) {
                    dataForm.cargoInformation.numberOfIdenticalLoads = 1;
                }
            },
            newDataForm,

            goToCargoPickup() {

                const fetchedSuitableOfficesCopy = newDataForm.fetchedSuitableOffices;

                newDataForm.$reset()

                newDataForm.fetchedSuitableOffices = fetchedSuitableOfficesCopy;
                
                newDataForm.sender.cityFrom = dataForm.sender.cityFrom;
                newDataForm.consignee.cityTo = dataForm.consignee.cityTo;

                newDataForm.sender.senderZaborType = dataForm.calculator.isCargoPickup;
                newDataForm.consignee.consigneeDeliveryType = dataForm.calculator.isDelivery;


                newDataForm.cargoInformation.typeOfCargo = typeOfCargosNew.find((type) => type.title === dataForm.cargoInformation.typeOfCargo);
                
                newDataForm.cargoInformation.numberOfIdenticalLoads = dataForm.cargoInformation.numberOfIdenticalLoads;
                newDataForm.cargoInformation.cargoDimensions.height = dataForm.cargoInformation.cargoDimensions.height
                newDataForm.cargoInformation.cargoDimensions.length = dataForm.cargoInformation.cargoDimensions.length
                newDataForm.cargoInformation.cargoDimensions.width = dataForm.cargoInformation.cargoDimensions.width
                
                newDataForm.cargoInformation.sizeOfCargoCylinder.diameter = dataForm.cargoInformation.sizeOfCargoCylinder.diameter;
                newDataForm.cargoInformation.sizeOfCargoCylinder.height = dataForm.cargoInformation.sizeOfCargoCylinder.height;


                newDataForm.thirdPerson.typeThirdPerson = dataForm.thirdPerson.typeThirdPerson;

                newDataForm.cargoInformation.cargoCost = dataForm.cargoInformation.cargoCost;

                newDataForm.cargoInformation.cargoWeight = dataForm.cargoInformation.cargoWeight;
                
                
                if (dataForm.services.cargoRedemption) {
                    newDataForm.thirdPerson.cargoTransportationCustomer = 'Получатель';
                    newDataForm.cargoInformation.cargoRedemption = dataForm.services.cargoRedemption;
                    newDataForm.cargoInformation.cargoRedemptionSum = dataForm.services.cargoRedemptionSum;
                } else {
                    newDataForm.thirdPerson.cargoTransportationCustomer = 'Отправитель';
                    newDataForm.cargoInformation.cashOnDelivery = dataForm.services.cashOnDelivery;
                    newDataForm.cargoInformation.cashOnDeliverySum = dataForm.services.cashOnDeliverySum;
                }

                
                newDataForm.cargoInformation.returnOfDocuments = dataForm.services.returnOfDocuments;
                useFetchAvailablePickUpTime();
                useFetchDeliveryTimeIntervals(dataForm.consignee.cityTo.id);
                router.push({ name: 'cargoPickup' });
            },

            checkCargoCost: function () {
                if (dataForm.cargoInformation.cargoCost < 3000) {
                    dataForm.cargoInformation.cargoCost = 3000;
                }
                if (dataForm.cargoInformation.cargoCost >= 30000) {
                    // dataForm.cargoInformation.additionalPackaging = true
                    // if (!dataForm.cargoInformation.typeOfPackaging.includes('Обрешётка')) {
                    //     dataForm.cargoInformation.typeOfPackaging.push('Обрешётка')
                    // }
                }
            },
            checkPackageType: function () {
                if (dataForm.cargoInformation.cargoCost >= 30000) {
                    // if (!dataForm.cargoInformation.typeOfPackaging.includes('Обрешётка')) {
                    //     dataForm.cargoInformation.typeOfPackaging.push('Обрешётка')
                    // }
                }
            },

            swapCities: function () {
                const cityFrom = dataForm.sender.cityFrom;
                dataForm.sender.cityFrom = dataForm.consignee.cityTo;
                dataForm.consignee.cityTo = cityFrom;
            },
            disableIdenticalCity: function (value, type) {
                if (value === dataForm.sender.cityFrom.title &&  type === 'to') {
                    return true
                }

                if (value === dataForm.consignee.cityTo.title &&  type === 'from') {
                    return true
                }

                return false
            },
            showLinkButtons
        };
    },
};
